import React from 'react';
import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '@bd-uikit-web/js-helpers/bdReq';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';

import { Elements, StripeProvider } from 'react-stripe-elements';
import StripeCheckoutFormNew from '../components/StripeCheckout/StripeCheckoutFormNew';
import '../components/StripeCheckout/stripe-checkout.scss';
import getEnvName from '@bd-uikit-web/js-helpers/getEnvName';

export default class Invoice extends React.Component {
  constructor(props) {
    super();
    this.props = props;
    const endDate = new Date();
    endDate.setMonth(endDate.getMonth() + 1);
    const user = bdAuth.getUser();

    this.state = {
      step: 1,
      sending: false,
      user,
      plan: {},
      showCheckoutModal: false,
      invoice: null,
      trial_end: this.formatDateToString(endDate)
    };
  }

  componentWillMount() {
    this.getInvoice(`/users/${this.state.user.id}/invoices/${this.props.match.params.invoiceId}`);
    this.setStateSending();
    this.onToken = (token) => {
      const apiLinkSubPlans = `/users/${this.state.user.id}/invoices/${this.props.match.params.invoiceId}`;
      console.log(apiLinkSubPlans);
      const apiData = {
        id: token.id,
        stripeToken: token.id,
        stripeEmail: token.email
      };
      this.postStripeToken(apiLinkSubPlans, apiData);
    };
  }

  // @todo move this to a static global place.
  setStateSending() {
    this.setState({
      sending: true
    });
  }

  getInvoice(invoiceUrl) {
    bdReq.get(invoiceUrl).then(({ success, body }) => {
      if (success) {
        this.setState({
          invoice: body,
          sending: false
        });
      }
    });
  }

  // @todo move this to a static global place.
  formatDateToString(date) {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];
    const dd = date.getDate();
    const MM = months[date.getMonth()];
    const yyyy = date.getFullYear();
    return `${MM} ${dd}, ${yyyy}`; // Note this format is different than the other function.
  }

  postStripeToken(apiLinkSubPlans, apiData) {
    bdReq.post(apiLinkSubPlans, apiData).then(({ success, body }) => {
      if (!success) {
        this.setState({
          sending: false
        });

        rootDispatcher.dispatch('NB:OPEN', {
          type: 'error',
          msg: body.message
        });
        return;
      }

      this.setState({
        sending: false,
        done: true
      });

      this.props.history.push('/thank-you');
    });
  }

  render() {
    const { invoice } = this.state;

    if (!invoice) {
      return <div className="spinner spinner--big" />;
    }

    const planName = invoice.subscription === '_commercial' ? 'Commercial' : 'Collector';

    return (
      <div className="container invoice">
        <section className="row row--push-btm-s">
          <div className="col-12 text-center">
            <img
              src={invoice && invoice.reseller.image ? invoice.reseller.image.location : null}
              style={{ maxWidth: '250px', maxHeight: '130px' }}
            />
          </div>
        </section>

        <section className="row row--push-btm-s">
          <div className="col-12">
            <section className="row">
              <div className="col-4">
                <div className={'plan-card plan-card--purchase'}>
                  <div className="plan-card__label" />
                  <header className="plan-card__header">
                    <h5 className="h--lower h--spacing-sm h--medium-weight">{planName}</h5>
                    <h1 className="plan-card__price" data-currency="$" data-period="/annual">
                      {invoice.subscriptionPrice}
                    </h1>
                  </header>
                  <ul className="current-plan-card__features current-plan-card__features-left">
                    <li>
                      <span className="checkmark-green ion-checkmark" />
                      Control 4 / Crestron
                    </li>
                    <li>
                      <span className="checkmark-green ion-checkmark" />
                      Curated art
                    </li>
                    <li>
                      <span className="checkmark-green ion-checkmark" />
                      {invoice.subscription === '_commercial' ? 'Commercial' : 'Private'} Use
                    </li>
                    <li>
                      <span className="checkmark-green ion-checkmark" />
                      Auto-renew
                    </li>
                  </ul>
                  <footer className="plan-card__footer" />
                </div>
              </div>

              <div className="col-8">
                <div className="card steps">
                  <section className={`step ${this.state.step === 1 ? 'active' : 'inactive'}`}>
                    <h4 className="h--lower h--spacing-sm h--medium-weight">{planName} subscription</h4>
                    <p>
                      You agree that you will get instant access to your {planName} subscription, you will automatically
                      be charged the subscription fee every year until you cancel. In the event of termination, you are
                      not entitled to a refund.
                    </p>

                    <h5 className="h--lower h--regular-weight h--spacing-sm">Breakdown:</h5>

                    <ul className="current-plan-card__features">
                      <li>
                        <div className="pull-left">{planName} subscription</div>

                        <div className="pull-right">${invoice.subscriptionPrice} / Annual</div>

                        <div className="clear" />
                      </li>
                      <li>
                        <div className="pull-left">{invoice.devices - 1} Additional screens</div>

                        <div className="pull-right">${(invoice.devices - 1) * invoice.devicePrice} / Annual</div>

                        <div className="clear" />
                      </li>
                    </ul>

                    <h5 className="h--lower h--regular-weight h--spacing-sm pull-left">Total</h5>
                    <h5 className="h--lower h--regular-weight h--spacing-sm pull-right">
                      ${invoice.subscriptionPrice + (invoice.devices - 1) * invoice.devicePrice}/ Annual
                    </h5>

                    <div className="clear" />

                    <br />
                    <button
                      type="submit"
                      className="button-no-float btn--dark btn--text-lower pull-left"
                      onClick={() => this.setState({ step: 2 })}
                    >
                      Purchase
                    </button>
                    <div className="clear" />
                  </section>
                  <section className={`step ${this.state.step === 2 ? 'active' : 'inactive'}`}>
                    <StripeProvider
                      apiKey={
                        getEnvName() === 'production'
                          ? 'pk_live_8YPTwOAeydlQbXQKYSHVDAI6'
                          : 'pk_test_CwFNQLF0fkyOp98BpMWd97hD'
                      }
                    >
                      <Elements>
                        <StripeCheckoutFormNew
                          amount={invoice.subscriptionPrice + (invoice.devices - 1) * invoice.devicePrice}
                          currency="USD"
                          email={this.state.user.email}
                          onToken={this.onToken}
                          back={() => this.setState({ step: 1 })}
                        />
                      </Elements>
                    </StripeProvider>
                  </section>
                </div>
              </div>
            </section>
          </div>
        </section>
        <section className="row row--push-btm-s">
          <div className="col-12 text-center">
            <span style={{ fontSize: '18px' }}>
              Not the right subscription? Contact your reseller:&nbsp;
              <a rel="noopener noreferrer" target="_blank" href={invoice ? invoice.reseller.website : '#'}>
                {invoice ? invoice.reseller.name : null}
              </a>{' '}
              below
            </span>
          </div>
        </section>
        <section className="row row--push-btm-s" style={{ fontSize: '16px' }}>
          <div className="col-12">
            <section className="row row--push-btm-s card reseller-info">
              <div className="col-4 text-center">
                <span>
                  Call:&nbsp;
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`callto:${invoice ? invoice.reseller.phone : null}`}
                  >
                    {invoice ? invoice.reseller.phone : null}
                  </a>
                </span>
              </div>
              <div className="col-4 text-center">
                <span>
                  Email:&nbsp;
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`mailto:${invoice ? invoice.reseller.email : null}`}
                  >
                    {invoice ? invoice.reseller.email : null}
                  </a>
                </span>
              </div>
              <div className="col-4 text-center">
                <span>
                  Website:&nbsp;
                  <a rel="noopener noreferrer" target="_blank" href={invoice ? invoice.reseller.website : null}>
                    {invoice ? invoice.reseller.website : null}
                  </a>
                </span>
              </div>
            </section>
          </div>
        </section>
      </div>
    );
  }
}
